(function () {
    /** @ngInject */
    function guestPageController($scope, $state, $http, $timeout) {
        $scope.booking.resetErrors();
        $scope.countryList = false;
        var tempReserveTime = null;
        var iti = false;
        $scope.allergies = !$scope.isGiftCard() && settings.allow_allergies;
        $scope.comment_type = (settings.comment ? 'allergies' : 'comment');
        $scope.setCommentType = function (t) {
            $scope.comment_type = t;
        }
        $scope.has_terms = settings.custom_reservation_request_terms;
        $scope.custom_request_terms = false;
        $scope.custom_request_amount = { amount: '' };
        var request_terms = false;
        $scope.additional_requests = settings.additional_requests;
        $scope.custom_request_dropins = { amount: false };
        $scope.custom_request_time = { opened: false, time: '' };
        $scope.is_bokabord_web = false;
        $scope.custom_request_times = new Array();
        var custom_request_times = {};
        $scope.cities = [
            'Stockholm',
            'Göteborg',
            'Malmö',
            'Åre',
            'Borås',
            'Båstad',
            'Gävle',
            'Halmstad',
            'Helsingborg',
            'Jönköping',
            'Kalmar',
            'Kristianstad',
            'Linköping',
            'Norrköping',
            'Luleå',
            'Lund',
            'Smögen',
            'Sundsvall',
            'Sälen',
            'Umeå',
            'Uppsala',
            'Vemdalen',
            'Visby',
            'Växjö',
            'Ystad',
        ];
        $scope.restTermsChanged = false;
        var gdprTimeout = null;
        var lastEmailChecked = $scope.booking.email;
        var resetAjax = () => {
            window.setTimeout(() => {
                $scope.ignoreAjaxService(false);
            }, 2500);
        }
        $scope.setCRAmount = function () {
            $scope.booking.amount = $scope.custom_request_amount.amount;
        }
        $scope.checkGDPR = function () {
            if (!settings.newsletter_due_to_GDPR || $scope.restTermsChanged)
                return;

            if (lastEmailChecked !== $scope.booking.email) {
                if (gdprTimeout) {
                    window.clearTimeout(gdprTimeout);
                }
                $scope.ignoreAjaxService(true);
                gdprTimeout = window.setTimeout(
                    () => {
                        // $scope.ignoreAjaxService(true);
                        $http.post("/booking-widget/api/getCustomerGDPR", { email: $scope.booking.email, hash: hash }).success(function (response) {
                            if (!response.hasOwnProperty('success') || response.success !== true) {
                                resetAjax();
                                return false;
                            } else {
                                $scope.booking.terms.restaurant = response.rest_newsletter;
                            }
                            resetAjax();
                        }).error(function () {
                            resetAjax();
                        })
                        gdprTimeout = null;
                        lastEmailChecked = $scope.booking.email;
                    }, 1500);
            }
        }
        $scope.important_tags = important_tags;
        $scope.language = language;
        $scope.setTag = function (tag) {
            if (_.isUndefined($scope.booking.important_tags)) {
                $scope.booking.important_tags = {};
            }
            $scope.booking.important_tags[tag.id] = 'Y';
        }
        $scope.resetTag = function (tag) {
            delete $scope.booking.important_tags[tag.id];
        }

        $scope.toggleTag = function (tag) {
            if ($scope.booking.important_tags && $scope.booking.important_tags[tag.id]) {
                $scope.resetTag(tag);
            } else {
                $scope.setTag(tag);
            }
        }
        $scope.setCustomRequestTime = function (time) {
            $scope.custom_request_time.time = time;
            $scope.custom_request_time.opened = false;
        };
        $scope.toggleRequestTime = function () {
            $scope.custom_request_time.opened = !$scope.custom_request_time.opened;
        };
        $scope.haveRequest = function (req) {
            return _.includes($scope.booking.additional_requests, req);
        };
        $scope.setRequest = function (req) {
            if (_.includes($scope.booking.additional_requests, req))
                _.pull($scope.booking.additional_requests, req);
            else
                $scope.booking.additional_requests.push(req);
        };
        if (testPhone === true) {
            $scope.guestPhone = angular.copy($scope.booking.phone);
            $scope.phoneValid = function () {
                if (!$scope.guestPhone || !$scope.guestPhone.length) return true;
                if (!iti) return false;
                return iti.isValidNumber();
            };
        }
        $scope.selectAmount = function (amount) {
            $scope.booking.amount = amount;
            $scope.custom_request_dropins.amount = false;
        };
        $scope.toggleTerms = function () {
            request_terms = !request_terms;
        }
        $scope.termsEnabled = function () {
            return request_terms;
        };
        $scope.canComment = function () {
            return settings.comment || $scope.comment_type === 'allergies';
        };
        $scope.isTestPhone = testPhone;
        $scope.next = function () {
            if (testPhone === true && iti) {
                if (!$scope.phoneValid()) return false;
                var _phone = iti._getFullNumber();
                $scope.booking.country_code = iti._getDialCode(_phone);
                _phone = _phone.replace($scope.booking.country_code, '');
                _phone = _phone.replace(/\s/g, '');
                _phone = _phone.replace(/^046/, '46');
                $scope.booking.phone = _phone;
            }
            if (!$scope.booking.hasErrors()) {
                //if its a custom reservation request, proceed accoridngly
                if ($scope.booking.custom_request === true) {
                    var custom_request_data = _.pick($scope.booking, ['firstname', 'lastname', 'phone', 'amount', 'comment', 'email', 'city']);
                    custom_request_data['date'] = $scope.booking.getDate('YYYY-MM-DD');
                    custom_request_data['hash'] = hash;
                    custom_request_data['time'] = $scope.custom_request_time.time;
                    custom_request_data['terms'] = request_terms;
                    custom_request_data['additional_requests'] = $scope.booking.additional_requests;
                    custom_request_data['mealid'] = $scope.booking.mealid;
                    //send reservation request

                    $http.post("/booking-widget/api/sendCustomRequest", custom_request_data).success(function (response) {
                        if (!response.hasOwnProperty('success') || response.success !== true) {
                            alert(response.errors);
                            return false;
                        } else {
                            if (typeof (window.top) !== 'undefined')
                                window.top.postMessage('scrollTop', "*");
                            $scope.booking.rr_id = response.rr_id;
                            $scope.booking.time = custom_request_data['time'];
                            $scope.goTo('success-custom-request');
                        }
                    });
                } else {
                    if (!$scope.isGiftCard() && (settings.allow_allergies && $scope.comment_type === 'allergies' && _.size($scope.booking.comment) <= 1)) {
                        alert((language === 'en' ? "Please enter allergies or choose no allergies" : "Vänligen ange vilka allergier gästerna har eller välj - Inga allergier"));
                        return;
                    }
                    completeBooking();
                    //$state.go('terms', {}, {location: false});
                }
            } else {
                document.querySelector('#first_name_field').focus();
            }
        };
        $scope.setCountryCode = function (code) {
            $scope.booking.country_code = '+' + code;
            $scope.countryList = false;
        };
        $scope.$on("$viewContentLoaded", function () {
            if (testPhone === true && intlTelInput) {
                var input = document.querySelector("input.phoneField");
                iti = intlTelInput(input, {
                    initialCountry: default_country_code,
                    preferredCountries: ['se', 'no', 'dk', 'es']
                });
                if ($scope.booking.phone)
                    window.setTimeout(function () {
                        iti._updateFlagFromNumber($scope.booking.phone);
                    }, 500);
            }
            if ($scope.booking.custom_request === true) {
                $scope.booking.date = null;
                $scope.booking.amount = 0;

                $timeout(() => {
                    var dp = TinyDatePicker(document.querySelector('#custom_request_date'), {
                        lang: {
                            days: moment.weekdaysShort(),
                            months: moment.months(),
                            close: 'Close'
                        },
                        format: function (date) {
                            return moment(date).format('D MMMM YYYY');
                        },
                        mode: 'dp-below',
                        min: moment().format('MM/DD/YYYY'),
                        max: moment().add('month', max_time || 3).date(30).format('MM/DD/YYYY'),
                        dayOffset: 1
                    }).on({
                        'select': function (_, dp) {
                            $scope.booking.date = moment(dp.state.selectedDate);

                            if (!custom_request_times.mealid || custom_request_times.mealid != $scope.booking.meal.id || !custom_request_times.date || custom_request_times.date != $scope.booking.getDate('YYYY-MM-DD')) {
                                $http.post("/booking-widget/api/getMealTimes", { mealid: $scope.booking.meal.id, date: $scope.booking.getDate('YYYY-MM-DD') }).success(function (response) {
                                    if (response.success !== true) {
                                        alert(response.errors);
                                        return false;
                                    }

                                    $scope.custom_request_times = response.meal_times;
                                    custom_request_times['mealid'] = $scope.booking.meal.id;
                                    custom_request_times['date'] = $scope.booking.getDate('YYYY-MM-DD');
                                });
                            }
                        },
                        'close': function () { }
                    });
                }, 500);
                updateWidgetStep('Custom-Request-Form');

            } else {
                updateWidgetStep('Guest-Form', { averageValue: $scope.booking.meal.avg_gtm_price, totalValue: ($scope.booking.meal.avg_gtm_price * $scope.booking.amount), meal: $scope.booking.meal.name, amount: $scope.booking.amount, date: $scope.booking.getDate('YYYY-MM-DD'), time: $scope.booking.time, products: _.size($scope.booking.booking_products) });
            }
            addECEvents();
            $scope.is_bokabord_web = is_bb == true;
            $scope.booking.terms.bokabord = is_bb == true;

            $scope.ignoreAjaxService(true);
            $http.post("/booking-widget/api/addContactStats", { hash: hash, mealid: $scope.booking.mealid, date: $scope.booking.getDate('YYYY-MM-DD'), time: $scope.booking.time, amount: $scope.booking.amount }).success(function (response) {
                if (response.success === true) {
                    $scope.booking.statistic_id = response.id;
                }
                resetAjax();
            });
        });
        $scope.request = false;
        $scope.skip_accept = false;

        if (settings.skip_general) {
            $scope.skip_accept = true;
            $scope.booking.terms.general = true;
        }
        /****
         * Completion step
         */
        function addECEvents() {
            if (typeof (dataLayer) !== 'undefined' && !testDt) {
                dataLayer.push({
                    'event': 'checkout',
                    'ecommerce': {
                        'checkout': {
                            'products': [
                                {
                                    'name': $scope.booking.meal.name,       // Name or ID is required.
                                    'brand': restaurant_name,
                                    'category': 'Bordsbokning',
                                    //'id': response.booking.id,
                                    'amount': $scope.booking.amount,
                                    'firstname': $scope.booking.firstname,
                                    'lastname': $scope.booking.lastname,
                                    'email': $scope.booking.email,
                                    'date': $scope.date,
                                    'time': $scope.booking.time,
                                    'waitlist': $scope.booking.waitlist ? 'Y' : 'N',
                                    'meal': $scope.booking.meal.name,
                                    'price': restaurant_gtm_price
                                }
                            ]
                        }
                    }
                });
                if (typeof (ga) !== 'undefined') {
                    ga('ec:addProduct', {
                        //'id': response.booking.id,// Product ID (string).
                        'name': 'Bordsbokning ', //+ response.booking.id, // Product name (string).
                        'category': 'Bordsbokning', // Product category (string).
                        'brand': restaurant_name,
                        'variant': $scope.booking.meal.name,
                        'price': restaurant_gtm_price,
                        'quantity': 1,
                        'dimension15': $scope.booking.amount,
                        'dimension16': $scope.booking.time,
                        'dimension17': $scope.booking.getDate('MMDDYY')
                    });
                }
            }
        }
        $scope.havePayment = function () {
            if ($scope.booking.meal.type == 9 || $scope.booking.meal.type == 10 || $scope.booking.meal.type == 8) return true;
            if ($scope.booking.meal.must_pay_directly == 'Y') return true;
            return $scope.booking.getProductsTotal() > 0;
        };
        $scope.canCompleteBooking = function () { return $scope.booking.terms.general === true && !$scope.request; };
        function completeBooking() {
            if (!$scope.booking.hasErrors(true)) {
                $scope.request = true;
                $scope.booking.is_bokabord_web = $scope.is_bokabord_web ? 'Y' : 'N';
                if($scope.booking.giftcard){
                    $state.go('payinwidget', {}, {location: false});
                    return;
                }
                $scope.booking.save().success(function (response) {
                    if (response.success !== true || !response.hasOwnProperty('booking')) {
                        alert(response.errors);
                        $scope.request = false;
                        return false;
                    }
                    var bookingObj = null;
                    if (response.booking && response.booking.id > 0) {
                        var d1 = moment(response.booking.date);
                        var d2 = moment();
                        bookingObj = {
                            'regDate': moment().format('YYYY-MM-DD HH:mm'),
                            'bookingDate': response.booking.date,
                            'bookingTime': response.booking.time_formatted,
                            'quantity': response.booking.amount,
                            'totalAmount': $scope.booking.getProductsTotal(),
                            'daysAhead': d1.diff(d2, 'days'),
                            'products': _.size($scope.booking.booking_products),
                            'meal': $scope.booking.meal.name,
                            'amount': $scope.booking.amount,
                            'date': response.booking.date,
                            'time': $scope.booking.time,
                            'averageValue': $scope.booking.meal.avg_gtm_price,
                            'totalValue': ($scope.booking.meal.avg_gtm_price * $scope.booking.amount)
                        };
                    }

                    updateWidgetStep('Reservation-Completed', bookingObj);
                    if (response.booking && response.booking.id > 0) {
                        $scope.booking.initFromDbObj(response.booking);
                        $scope.date = $scope.booking.getDate('YYYY-MM-DD');
                        if (typeof (dataLayer) !== 'undefined' && !testDt) {
                            dataLayer.push({
                                //'event' : 'purchase',
                                'ecommerce': {
                                    'purchase': {
                                        'actionField': {
                                            'id': response.booking.id,
                                            'revenue': restaurant_gtm_price,
                                        },
                                        'products': [
                                            {
                                                'name': $scope.booking.meal.name,       // Name or ID is required.
                                                'brand': restaurant_name,
                                                'category': 'Bordsbokning',
                                                'quantity': $scope.booking.amount,
                                                'firstname': $scope.booking.firstname,
                                                'lastname': $scope.booking.lastname,
                                                'email': $scope.booking.email,
                                                'date': $scope.date,
                                                'dimension15': $scope.booking.amount,
                                                'dimension16': $scope.booking.time,
                                                'dimension17': $scope.booking.getDate('MMDDYY'),
                                                'time': $scope.booking.time,
                                                'waitlist': $scope.booking.waitlist ? 'Y' : 'N',
                                                'meal': $scope.booking.meal.name,
                                                'price': restaurant_gtm_price
                                            }
                                        ]
                                    }
                                }
                            });
                            if (typeof (ga) !== 'undefined') {
                                ga('ec:addProduct', {
                                    'id': response.booking.id,// Product ID (string).
                                    'name': 'Bordsbokning #' + response.booking.id, // Product name (string).
                                    'category': 'Bordsbokning', // Product category (string).
                                    'brand': restaurant_name,
                                    'variant': $scope.booking.meal.name,
                                    'price': restaurant_gtm_price,
                                    'quantity': 1,
                                    'dimension15': $scope.booking.amount,
                                    'dimension16': $scope.booking.time,
                                    'dimension17': $scope.booking.getDate('MMDDYY')
                                });
                            }
                        }
                        if (typeof (window.parent) !== 'undefined') {
                            window.parent.postMessage("reservationSuccess", "*");
                        }
                        if (typeof (dataLayerBokabord) !== 'undefined') {
                            dataLayerBokabord.push({
                                'event': 'Final-Confirmation',
                                'restaurant': restaurant_name
                            });
                        }

                        if (response.booking.status === 0) {
                            $state.go('payinwidget', {}, { location: false });
                        } else {
                            window.setTimeout(function () {
                                window.location = '/reservation/booking/?code=' + response.booking.short_code + '&new=1';
                            }, 1000);
                        }
                    }
                });
            }
        }
    }
    angular.module("Waiteraid").controller("guestCtrl", guestPageController);
})();
